import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const AttendanceService = {
  add,
  getAllAttendanceLimit,
  getAllEnrolledStudents,
  updatAttendance,
  deletAttendance,
};

async function getAllEnrolledStudents(
  node_mid,
  form_id,
  lg_user_id,
  lg_user_table_id
) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/attendances/getAllEnrolledStudents/${node_mid}/${form_id}/${lg_user_id}/${lg_user_table_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllAttendanceLimit(
  node_mid,
  limit,
  offset,
  atten_date,
  create_user_id,
  create_user_table_id,
  user_table_id,
  stu_id,
  sortColumn,
  sortDirection,
  search_term,
  owner_restriction
) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/attendances/getAll/${node_mid}/${limit}/${offset}/${sortColumn}/${sortDirection}?atten_date=${atten_date}&create_user_id=${create_user_id}&create_user_table_id=${create_user_table_id}&user_table_id=${user_table_id}&stu_id=${stu_id}&search_term=${search_term}&owner_restriction=${owner_restriction}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

//add a new city
async function add(newAttendance) {
  const configOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(newAttendance),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/attendances/add`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function updatAttendance(updatAttendance , id){

  const requestOptions = {
      method: "PUT",
      headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      body: JSON.stringify(updatAttendance),
    };
    const response = await fetch(
      `${config.oat_api_url}/manage/attendances/update/${id}`,
      requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function deletAttendance(id){

  const requestOptions = {
      method: "DELETE",
      headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      body: JSON.stringify(updatAttendance),
    };
    const response = await fetch(
      `${config.oat_api_url}/manage/attendances/delete/${id}`,
      requestOptions
    );
    return APIHandler.handleResponse(response);
}
